export default __webpack_public_path__ + "static/map-1-1-b8f39b189e33a4b8ace9a921db3bfe6f.png";